import { Component } from '@angular/core';
import PackageJson from '@root/package.json';


@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss'],
  standalone: true,
})
export class VersionComponent {
  readonly appVersion = PackageJson.version;
}
